// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-modal {
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 11;
  height: 100dvh;
  position: fixed;
}
.side-modal__close-page {
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-in-out;
}
.side-modal__wrapper-modal {
  right: 0;
  bottom: 0;
  z-index: 2;
  width: 95%;
  height: 100dvh;
  overflow: auto;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: var(--sebrae-white);
  box-shadow: 0 1px 30px 6px rgba(20, 46, 82, 0.2);
  transform: translateX(100%);
  transition: transform 0.2s ease-in-out;
}
.side-modal__content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.side-modal__header {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 32px 30px 23px 32px;
  height: 56px;
  background-color: var(--sebrae-white);
}
.side-modal__btn-close {
  border: 0;
  padding: 0;
  right: 10px;
  position: absolute;
  width: 23px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.side-modal__btn-close img {
  width: 23px;
  height: 23px;
}
.side-modal__title {
  font-size: 18px;
  font-weight: 700;
  color: var(--sebrae-gray);
  line-height: 1.2;
}
.side-modal__body {
  padding: 10px 16px 0;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
}
.side-modal__footer {
  width: 100%;
  padding: 16px;
  background-color: var(--sebrae-white);
}
.side-modal.open .side-modal__close-page {
  background: rgba(0, 0, 0, 0.3);
}
.side-modal.open .side-modal__wrapper-modal {
  transform: translateX(0);
}
@media screen and (min-width: 768px) {
  .side-modal__title {
    font-size: 23px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/sidemodal/index.scss"],"names":[],"mappings":"AAAA;EACE,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AACF;AACE;EACE,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;AACJ;AACE;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,gDAAA;EACA,2BAAA;EACA,sCAAA;AACJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;AACE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,YAAA;EACA,qCAAA;AACJ;AACE;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AAEE;EAEI,eAAA;EACA,gBAAA;EAEF,yBAAA;EACA,gBAAA;AAFJ;AAIE;EACE,oBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;AAFJ;AAIE;EACE,WAAA;EACA,aAAA;EACA,qCAAA;AAFJ;AAMI;EACE,8BAAA;AAJN;AAMI;EACE,wBAAA;AAJN;AAQE;EACE;IACE,eAAA;EANJ;AACF","sourcesContent":[".side-modal {\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 11;\n  height: 100dvh;\n  position: fixed;\n\n  &__close-page {\n    top: 0;\n    left: 0;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    transition: all .2s ease-in-out;\n  }\n  &__wrapper-modal {\n    right: 0;\n    bottom: 0;\n    z-index: 2;\n    width: 95%;\n    height: 100dvh;\n    overflow: auto;\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--sebrae-white);\n    box-shadow: 0 1px 30px 6px rgba(20, 46, 82, 0.2);\n    transform: translateX(100%);\n    transition: transform .2s ease-in-out;\n  }\n  &__content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n  &__header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    padding: 32px 30px 23px 32px;\n    height: 56px;\n    background-color: var(--sebrae-white);\n  }\n  &__btn-close {\n    border: 0;\n    padding: 0;\n    right: 10px;\n    position: absolute;\n    width: 23px;\n    height: 23px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      width: 23px;\n      height: 23px;\n    }\n  }\n  &__title {\n    font: {\n      size: 18px;\n      weight: 700;\n    }\n    color: var(--sebrae-gray);\n    line-height: 1.2;\n  }\n  &__body {\n    padding: 10px 16px 0;\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n  }\n  &__footer {\n    width: 100%;\n    padding: 16px;\n    background-color: var(--sebrae-white);\n  }\n\n  &.open {\n    .side-modal__close-page {\n      background: rgba(0, 0, 0, 0.30);\n    }\n    .side-modal__wrapper-modal {\n      transform: translateX(0);\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    &__title {\n      font-size: 23px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
